<template>
	<page-layout class="calendar-page" title="Kalender">
		<div class="content">
			<div class="header">
				<div @click="dateClick">{{ date.getDate() }}. {{ months[date.getMonth()] }} {{ date.getFullYear() }}</div>
			</div>
			<div class="body">
				<div class="table" v-sortable="{
					animation: 150,
					store: {
						get: getOrder,
						set: setOrder
					}
				}">




					<div v-for="(book, i) in bookings" :key="i" :data-id="book.id" :class="{
						item: true,
						move: true,
						closed: book.closed ? true : false
					}" v-touch:tap="taskTouchHandler(book.id)">
						<div class="color" :style="{
							backgroundColor: _taskTypes.hasOwnProperty(book.type) ? _taskTypes[book.type].color : 'black'
						}"></div>
						<div class="title">#{{ $filters.number(parseInt(book.num), 0) || $filters.number(0) }} {{ book.name }}</div>
						<div class="sub-title">{{ book.hasOwnProperty('hour_rate') ? (book.hour_rate > 0 ? 'TP ' : 'FP ') : '' }}{{ _taskTypes.hasOwnProperty(book.type) ? _taskTypes[book.type].label : '' }}</div>
						<div class="arrival">{{ arrival(book) }}</div>
						<div class="info">
							<div class="tag">{{ zip(book) }}</div>
						</div>
						<div v-if="tags(book).length > 0" class="tags">
							<span v-for="(tag, i) in tags(book)" :key="i" class="tag">{{ _instructions.hasOwnProperty(tag) ? _instructions[tag].label : '' }}</span>
						</div>
					</div>



				
				</div>
			</div>
		</div>
	</page-layout>
</template>

<script>
	import PageLayout from '@/app/layouts/PageLayout'
	import UserFragment from '@/app/fragments/UserFragment'
	import DatePopupView from '@/components/DatePopupView'

	export default {
		components: {
			pageLayout: PageLayout
		},
		data() {
			return {
				date: new Date(),
				columns: [
					{
						data: ['username'],
						label: 'Username'
					},
					{
						type: 'button',
						data: {
							event: 'delete',
							label: 'Delete'
						},
						label: '',
						weight: '200px',
						align: 'right'
					}
				],
				items: [
					{
						username: 'nicolaj'
					}
				],
				taskTypes: [],
				reservations: [],
				bookings: [],
				instructions: [],
				months: [
					'januar',
					'februar',
					'marts',
					'april',
					'maj',
					'juni',
					'juli',
					'august',
					'september',
					'oktober',
					'november',
					'december'
				]
			};
		},
		watch: {
			date(n) {
				this.reservations = [];
				this.bookings = [];
				this.update();

				localStorage.setItem('calendar_date', n.toString());

				console.log('Date stored!!');
			}
		},
		computed: {
			_taskTypes() {
				var r = {};

				for (var i = 0; i < this.taskTypes.length; ++i) {
					r[this.taskTypes[i].name] = this.taskTypes[i];
				}

				return r;
			},
			_instructions() {
				var r = {};

				for (var i = 0; i < this.instructions.length; ++i) {
					r[this.instructions[i].name] = this.instructions[i];
				}

				console.log(r);

				return r;
			}
		},
		methods: {
			taskTouchHandler(id) {
				var self = this;

				return function (direction, event) {
					self.$router.push({ name: 'move', params: { id: id }, query: self.$route.query })
				}
			},
			arrival(book) {
				//console.log('print arrival', book.due_start_from.replace('+', 'T'), new Date(book.due_start_from.replace('+', 'T')));

				var from 	= this.$filters.moment(book.due_start_from, 'HH:mm');
				var to 		= this.$filters.moment(book.due_start_to, 'HH:mm');

				return from == to ? from : from + ' - ' + to;
			},
			zip(book) {
				if (book.type == 'move') {
					var zip1 = book.details.route[0].zip;
					var zip2 = book.details.route[book.details.route.length - 1].zip;
					return zip1 == zip2 ? zip1 : zip1 + ' - ' + zip2;
				}

				return book.details.address.zip;
			},
			tags(book) {
				var r = [];

				if (book.type == 'move') {
					for (var i = 0; i < book.details.route.length; ++i) {
						if (!Array.isArray(book.details.route[i].instructions)) {
							for (var instr in book.details.route[i].instructions) {
								//var name = book.details.route[i].instructions[instr];
								if (!r.includes(instr)) r.push(instr);
							}
						}
					}
				}

				return r;
			},
			create() {
				var self = this;

				this.$store.commit('pushModal', {
					component: UserFragment,
					props: {},
					events: {
						created() {
							self.update();
						}
					}
				});

				
			},
			getOrder(sortable) {
				console.log('get order', sortable);

				var tasks = Array.from(this.bookings);

				tasks.sort(function (a, b) {
					if (a.order < b.order) return -1;
					if (a.order > b.order) return 1;
					return 0;
				});

				var order = tasks.map(function (item) {
					return item.id;
				});
				
				console.log('order', order);

				return order;
			},
			setOrder(sortable) {
				console.log('set order', sortable.toArray());
				this.axios.put('/employees/me/tasks/order/', sortable.toArray());
			},
			itemMove(e) {
				/*console.log('item moved 5', e, this.bookings);

				// Change pos in list
				console.log('before', this.bookings.map(function (item) { return item.num; }));

				this.bookings.move(e.oldIndex - 1, e.newIndex - 1);

				console.log('after', this.bookings.map(function (item) { return item.num; }));
				
				var ids = this.bookings.map(function (item) {
					return item.booking_id;
				});

				console.log(ids);

				this.axios.put('/employees/me/bookings/order', ids);*/
			},
			itemClick(item) {
				var self = this;

				console.log(item);

				this.$store.commit('pushModal', {
					component: UserFragment,
					props: {
						id: item.id
					},
					events: {
						updated() {
							self.update();
						}
					}
				});
			},
			itemDelete(item) {
				var self = this;

				this.axios.delete('/portal/users/' + item.id + '/').then(function () {
					self.update();
				});
			},
			update() {
				var self = this;

				this.axios.get('/me/bookings/' + this.date.getFullYear() + '/' + (this.date.getMonth() + 1) + '/' + this.date.getDate() + '/').then(function (r) {
					self.bookings = r.data;
				});

				this.axios.get('/me/reservations/' + this.date.getFullYear() + '/' + (this.date.getMonth() + 1) + '/' + this.date.getDate() + '/').then(function (r) {
					self.reservations = r.data;
				});
			},
			dateClick() {
				var self = this;

				this.$store.commit('pushPopup', {
					component: DatePopupView,
					props: {
						title: 'Vælg dato',
						date: this.date,
						callback(e) {
							console.log(e);
							self.date = e;
							self.$store.commit('popPopup');
						},
						actions: [
							{
								label: 'Annuller',
								callback() {
									self.$store.commit('popPopup');
								}
							}
						]
					}
				});
			}
		},
		created() {
			//console.log('CREATE CalendarView');
			//localStorage.removeItem('calendar_date');
		},
		mounted() {
			console.log('mounted');

			var date = localStorage.getItem('calendar_date');

			if (date) {
				console.log('date found', date, new Date(date));
				this.date = new Date(date);
			} else {
				this.update();
			}

			var self = this;

			this.axios.get('/tasks/types/').then(function (r) {
				self.taskTypes = r.data._items;
			});

			this.axios.get('/tasks/instructions/').then(function (r) {
				self.instructions = r.data._items;
			});
		}
	}
</script>

<style lang="scss" scoped>
	.calendar-page {
		& > .content {
			display: grid;
			grid-template-rows: 60px 1fr;

			& > .header {
				border-bottom: 4px solid #f0f0f0;
				font-size: 14px;
				font-weight: bold;
				padding-left: 20px;
				line-height: 60px;

				& > .icon {
					width: 24px;
					height: 24px;
				}
			}

			& > .body {
				overflow-y: auto;
				background: rgb(241, 241, 241);

				& > .table {
					display: grid;
					row-gap: 10px;
					padding: 10px;
					overflow-y: auto;

					& > .item {
						background-color: white;
						position: relative;
						border-radius: 5px;
						overflow: hidden;
						min-height: 63px;

						-webkit-box-shadow: 0px 0px 5px 0px rgba(0,0,0,0.1);
						-moz-box-shadow: 0px 0px 5px 0px rgba(0,0,0,0.1);
						box-shadow: 0px 0px 5px 0px rgba(0,0,0,0.1);

						& > .color {
							position: absolute;
							left: 0;
							top: 0;
							width: 5px;
							height: 100%;
						}

						& > .title {
							font-size: 18px;
							font-weight: bold;
							position: absolute;
							left: 15px;
							top: 8px;
							right: 120px;
							line-height: 24px;
							white-space: nowrap;
							overflow: hidden;
							text-overflow: ellipsis;

							& > .completed {
								position: relative;
								top: -1px;
								padding: 2px 5px 2px 5px;
								background-color: rgb(36, 165, 11);
								color: white;
								text-align: center;
								border-radius: 3px;
								margin-right: 5px;
								font-size: 14px;
								line-height: 18px;
								font-weight: normal;
							}
						}

						& > .arrival {
							position: absolute;
							right: 10px;
							top: 10px;
							font-size: 16px;
							line-height: 18px;
						}

						& > .sub-title {
							position: absolute;
							left: 15px;
							top: 33px;
							line-height: 18px;
						}

						& > .info {
							position: absolute;
							right: 10px;;
							top: 33px;

							& > .tag {
								color: gray;
								margin-left: 5px;
								font-size: 12px;
								padding: 0 3px 0 3px;
								border: 1px solid gray;
								border-radius: 3px;
								line-height: 16px;
								float: left;
							}
						}

						& > .tags {
							margin-top: 61px;
							border-top: 1px solid rgb(221, 221, 221);
							padding: 10px;

							& > .tag {
								background-color: #F7223F;
								color: white;
								margin: 0 5px 10px 0;
								font-size: 12px;
								padding: 0 3px 0 3px;
								border: 1px solid #F7223F;
								border-radius: 3px;
								line-height: 16px;
								float: left;
							}
						}

						&.green {
							background-color: #00c017;
							color: white;
						}

						&.yellow {
							background-color: #e0d800;
							color: white;
						}

						&.red {
							background-color: #F7223F;
							color: white;
							height: 40px;
							min-height: 0;
						}

						&.closed {
							background-color:rgb(36, 165, 11);
							color: white;

							& > .info > .tag {
								color: white;
								border: 1px solid white;
							}
						}
					}
				}
			}
		}
	}
</style>